module.exports = __webpack_public_path__ + "static/img/6.4547e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/6.jpg
// module id = H1n1
// module chunks = 1